import { format } from 'date-fns';

export function formatDateForScheduling(date: Date | null) {
  if (!date) return;

  return new Date(format(new Date(date + 'Z'), "yyyy-MM-dd'T'HH:mm:ss"));
}
